
// Plum Vinyl Inline Fix
document.addEventListener('DOMContentLoaded', function() {
    // Fix translation errors
    document.querySelectorAll('*').forEach(function(el) {
        if (el.textContent.includes('Translation missing')) {
            if (el.textContent.includes('sort_by')) {
                el.textContent = 'Sort by';
            }
            if (el.textContent.includes('filter_by')) {
                el.textContent = 'Filter';
            }
        }
    });

    // Fix Japanese text
    document.querySelectorAll('.facets__label, .filter-label').forEach(function(el) {
        if (el.textContent.includes('出品状況')) {
            el.textContent = 'Availability';
        }
        if (el.textContent.includes('価格')) {
            el.textContent = 'Price';
        }
    });

    // Ensure images are visible
    document.querySelectorAll('.card__media img').forEach(function(img) {
        if (img.src) {
            img.style.display = 'block';
            img.style.visibility = 'visible';
            img.style.opacity = '1';
        }
    });
});
